@if (open()) {
  <div class="export-selector__backdrop" (click)="cancel()" aria-hidden="true"></div>
  <div class="export-selector__dialog-wrap">
    <div
      class="export-selector__panel"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'ACTIONS.GENERATE_REPORT' | translate"
    >
      <div class="export-selector__header">
        <div [style.display]="'flex'">
          <div class="export-selector__header__icon">
            <lib-icon name="Download" [size]="20"></lib-icon>
          </div>
          <div>
            <h3 class="export-selector__title">{{ 'ACTIONS.GENERATE_REPORT' | translate }}</h3>
            <span class="export-selector__subtitle">
              {{ 'COMMON.EXPORT.SUBTITLE' | translate }}
            </span>
          </div>
        </div>
        <lib-button
          variant="icon-ghost"
          prefixIcon="X"
          (clicked)="cancel()"
          [disabled]="loading()"
          [attr.aria-label]="'ACTIONS.CLOSE' | translate"
        >
        </lib-button>
      </div>

      <div class="export-selector__body">
        <div class="export-selector__body__content-header__title-row">
          <section>
            <h3 class="export-selector__body__content-header__title">
              {{ 'COMMON.EXPORT.FORMAT' | translate }}
            </h3>
          </section>

          <span class="export-selector__body__content-header__divider"></span>
        </div>
        <div class="contenido-items" role="radiogroup">
          @for (item of optionsWithText(); track item.value) {
            <button
              type="button"
              class="contenido-item"
              [attr.aria-checked]="selectedFormat() === item.value"
              [attr.data-active]="selectedFormat() === item.value ? '' : null"
              (click)="onFormatChange(item.value)"
              role="radio"
            >
              @if (item?.icon) {
                <lib-icon [name]="item.icon" class="contenido-item__icono" aria-hidden="true" />
              }
              <span class="contenido-item__texto">
                <span class="contenido-item__label">{{ item.label | translate }}</span>
                <span class="contenido-item__hint">{{ item.text | translate }}</span>
              </span>
              @if (selectedFormat() === item.value) {
                <lib-icon name="CircleCheck" class="contenido-item__marca" aria-hidden="true" />
              }
            </button>
          }
        </div>
      </div>

      <div class="export-selector__footer">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="cancel()">
          {{ 'ACTIONS.CANCEL' | translate }}
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="!selectedFormat() || loading()"
          [loading]="loading()"
          (clicked)="confirmDownload()"
        >
          {{ 'ACTION.DOWNLOAD' | translate }}
        </lib-button>
      </div>
    </div>
  </div>
}
